import { message } from "antd";
import { FirebaseError } from "firebase/app";

function handleFirebaseError(error: FirebaseError) {
    switch (error.code) {
        case "auth/network-request-failed":
            message.error("Network error. Please check your connection.");
            break;
        case "auth/invalid-credential":
            message.error("Invalid login. Please try again.");
            break;
        case "permission-denied":
        case "firestore/permission-denied":
            message.error("You don’t have permission to access this data.");
            break;
        case "invalid-argument":
        case "firestore/invalid-argument":
            message.error("Invalid request. Please contact support.");
            break;
        default:
            message.error("A Firebase error occurred. Please try again.");
    }
}

export default function initGlobalErrorHandler() {
    window.onerror = function (msg, url, lineNo, columnNo, error) {
        console.error("Global Error:", { msg, url, lineNo, columnNo, error });
        message.error("Something went wrong. Please try again later.");
        return false;
    };

    window.onunhandledrejection = function (event) {
        console.error("Unhandled Rejection:", event.reason);

        if (event.reason instanceof FirebaseError) {
            handleFirebaseError(event.reason);
        } else {
            message.error("An unexpected error occurred. Please try again.");
        }
    };
}
